import { SocialSharingGroup } from '@change/ds-core-ui';

import { useShareActions } from '#src/app/pages/psf/promoteOrShare/shared/hooks';
import { CopyLinkVisibleUrlButton, RoundShareIconButton } from '#src/app/shared/components/share';

import { splitShareButtonConfigsByCopy } from '../../utils/splitShareButtonConfigsByCopy';
import { ShareSectionHeading } from '../ShareSectionHeading';

export const InlineShareActions: React.FC<EmptyProps> = () => {
	const {
		data: { buttonConfigs },
	} = useShareActions();

	if (buttonConfigs.length === 0) return null;

	const { copyConfig, socialConfigs } = splitShareButtonConfigsByCopy(buttonConfigs);

	return (
		<div className="mb-3 flex flex-col gap-5">
			<ShareSectionHeading />
			<div className="flex flex-col gap-4">
				{copyConfig && (
					<CopyLinkVisibleUrlButton
						buttonConfig={{ ...copyConfig, urlDescription: copyConfig.secondaryLabel }}
						data-qa="psf-promote-or-share-inline-copy-button"
					/>
				)}
				{socialConfigs.length > 0 && (
					<SocialSharingGroup layout="grid" className="items-start justify-items-center gap-y-5 md:grid-cols-5">
						{socialConfigs.map((buttonConfig) => (
							<RoundShareIconButton
								key={buttonConfig.channel}
								buttonConfig={buttonConfig}
								className="text-center"
								data-qa={`psf-promote-or-share-inline-${buttonConfig.channel}-button`}
							/>
						))}
					</SocialSharingGroup>
				)}
			</div>
		</div>
	);
};
